var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "popup__layer active" }, [
    _c("div", { staticClass: "popup__edit big" }, [
      _c(
        "div",
        {
          staticClass: "popup__close",
          on: {
            click: function($event) {
              return _vm.close(true)
            }
          }
        },
        [_c("span", { staticClass: "glicon-close-large" })]
      ),
      _c("div", { staticClass: "popup__feedback" }, [
        _vm._m(0),
        _c("div", { staticClass: "popup__feedback--subtitle" }, [
          _vm._v(
            " " + _vm._s(_vm.$t("account.forms.deactivateReferralTitle")) + " "
          )
        ]),
        _c("div", { staticClass: "popup__feedback--text" }, [
          _vm._v(
            " " + _vm._s(_vm.$t("account.forms.deactivateReferralText")) + " "
          )
        ]),
        _c("div", { staticClass: "popup__feedback--text no-padding" }, [
          _vm._v(
            " " +
              _vm._s(_vm.$t("account.forms.deactivateReferralTextSecondary")) +
              " "
          )
        ])
      ]),
      _c(
        "div",
        { staticClass: "popup__buttons" },
        [
          _c("gl-button", {
            attrs: {
              id: "config.deactivate-referral",
              "color-secondary": "",
              type: "button",
              text: _vm.$t("account.forms.deactivateReferral")
            },
            on: {
              onClick: function($event) {
                $event.preventDefault()
                return _vm.close(false)
              }
            }
          }),
          _c("gl-button", {
            attrs: {
              id: "config.activate-referral",
              "color-primary": "",
              type: "button",
              text: _vm.$t("account.forms.activateReferral")
            },
            on: {
              onClick: function($event) {
                $event.preventDefault()
                return _vm.close(true)
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "popup__feedback--image failed" }, [
      _c("span", { staticClass: "glicon-alert-thin" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }